import React from "react";
import PropTypes from "prop-types";
import { Navigate, useLocation } from "react-router-dom";

/**
 * Route-level auth guard (S-12). Redirects to `/` when no access token is
 * present BEFORE the wrapped component mounts, so it cannot fire its initial
 * network calls with a missing/expired token.
 *
 * This is still a client-side check and is not authoritative — the backend
 * must reject requests that arrive without a valid token. But it closes the
 * most common "UI flashes before redirect" leak.
 */
export default function RequireAuth({ children }) {
  const location = useLocation();
  const token = typeof window !== "undefined" && window.localStorage?.getItem("access_token");
  if (!token) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }
  return children;
}

RequireAuth.propTypes = {
  children: PropTypes.node,
};
